// Module
var code = `<table class="misc-transaction__accounts-table table">
  <thead>
  <tr>
    <th>Nr.</th>
    <th>Account</th>
    <th>Debit amount</th>
    <th>Credit amount</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td>1.</td>
    <td>
      <select disabled>
        <option>{{ 'CASHIER_CHECK' | translateEnum:'LABEL' }}</option>
      </select>
    </td>
    <td>
      <cash ng-disabled="true"></cash>
    </td>
    <td>
      <cash value="\$ctrl.calculateDebitSum().toFixed(2)"
        ng-disabled="true"></cash>
    </td>
    <td></td>
  </tr>
  <tr ng-repeat="unit in \$ctrl.transaction.units">
    <td>{{\$index + 2 +'.'}}</td>
    <td>
      <selectize
        options="\$ctrl.options"
        config="\$ctrl.selectConfig"
        ng-model="unit.accountCode"
        required>
      </selectize>
    </td>
    <td>
      <cash ng-required="true"
        ng-model="unit.amount"></cash>
    </td>
    <td>
      <cash ng-disabled="true"></cash>
    </td>
    <td>
      <a ng-if="true" class="btn btn-danger" ng-click="\$ctrl.removeAccount(\$index)">Remove</a>
    </td>
  </tr>
  <tr class="add-account">
    <td class="add-account__remarks"><strong>Remarks:</strong></td>
    <td>
      <input
        required
        type="text"
        class="add-account__remarks-input"
        ng-model="\$ctrl.transaction.remarks"/>
      <span class="add-account__remarks-total"><strong>Total:</strong></span>
    </td>
    <td>
      <cash value="\$ctrl.calculateDebitSum().toFixed(2)"
        ng-disabled="true"></cash>
    </td>
    <td>
      <cash value="\$ctrl.calculateDebitSum().toFixed(2)"
        ng-disabled="true"></cash>
    </td>
    <td>
      <a
        class="btn btn-success"
        ng-click="\$ctrl.addAccountRow()">
        Add new
      </a>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/misc-transaction-units/transaction-units.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;